// extracted by mini-css-extract-plugin
export default {"nested_social_action":"social-actions-NestedSocialAction__nested_social_action--2mhpU","pad_right":"social-actions-NestedSocialAction__pad_right--3zjLW"};